module.exports = __webpack_public_path__ + "img/oilfox-sm.4a7dc44f.svg";